module.exports = "../fonts/telemedicine_logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telemedicine_logo.svg
// module id = 317
// module chunks = 0